import CardContent from "@mui/material/CardContent";
import { styled } from "@mui/material/styles";

const SompoCardContent = styled(CardContent)({
    padding: "0.5rem",
    "&:last-child": {
        paddingBottom: "0.5rem",
    },
});

export default SompoCardContent;
